import { render, staticRenderFns } from "./FacturacionPantalla.vue?vue&type=template&id=c1111638&"
import script from "./FacturacionPantalla.vue?vue&type=script&lang=ts&"
export * from "./FacturacionPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports